export const LocStrings: any = {
    "en-us":  {
                  "CheckoutError":  "Something went wrong. Checkout not completed.",
                  "FailureHandlerError": "There was an issue with your purchase. Return to checkout to choose another payment option.",
                  "SuccessHandlerError": "Challenge complete. Return to checkout to finish your purchase.",
                  "CancelHandlerError": "Challenge canceled. Return to checkout to choose another payment option.",
                  "AuthenticatePurchaseHeader": "Authenticate your purchase",
                  "AuthenticatePurchaseInstructions": "To complete your purchase, please follow the instructions provided by your bank. Please wait. This page can take 5-10 seconds to load."
              }
};
